<template>
	<div class="wrap-files display-flex-center">
		<div class="article-file" v-for="(item, index) of dataSource" :key="index" style="margin-right: 10px;">
			<ListFilesButtons v-if="item.listTrainingDocuments.length > 0" :title="item.name" :type="item.fileExtension" :dataSource="item.listTrainingDocuments" />
		</div>
		<a v-if="ebooksDetail && ebooksDetail.trainingId" href="javascript:;" class="btn btn-main-light border-rd-20 font-size-16 line-height-1-3" @click="directTrainingApp">
			Tài liệu tập huấn 
		</a>
		<!-- <ListFilesArticle v-if="dataPowerpoint && dataPowerpoint.length > 0" :title="'Powerpoint'" :type="typePow" :dataSource="dataPowerpoint" />
		<ListFilesArticle v-if="dataVideo && dataVideo.length > 0" :title="'Video'" :type="typeVideo" :dataSource="dataVideo" /> -->
	   	<div class="show-document" v-if="visiblePreviewModal">
	        <div class="inner-content js-model active">
	        	<ModalPreviewDocMedia />
	        	<div class="js-background-model active" @click="handleOffModal"></div>
	        </div>
	    </div>
	</div>
</template>

<script>
	import ListFilesButtons from './ListFilesButtons.vue'
	import ModalPreviewDocMedia from './ModalPreviewDocMedia.vue'
	// import { CONTENT_TYPE_VIDEO, CONTENT_TYPE_PDF, CONTENT_TYPE_WORD, CONTENT_TYPE_POWERPOINT } from '@/store/common/constants'
	import { mapGetters, mapActions } from 'vuex'
	import { STORE_KEY as STORE_KEY_BOOK } from '@/modules/ebooks/_store/constants'


	export default {
		name: 'SectionFilesButton',
		props: {
			dataDocPdf: Array,
			dataVideo: Array,
			dataPowerpoint: Array,
			dataSource: Array
		},
		data() {
			return {
			};
		},
		computed: {
			...mapGetters({
				visiblePreviewModal: 'common/visiblePreviewModal',
				docPreview: 'common/docPreview',
				ebooksDetail: STORE_KEY_BOOK + '/ebooksDetail'
			})
		},
		components: {
			ListFilesButtons,
			ModalPreviewDocMedia
		},
		methods: {
			...mapActions('common', ['toggleModalPreview', 'setDocPreviewContent']),

			handleOffModal() {
				this.toggleModalPreview(false)
				this.setDocPreviewContent({})
			},

			/**
			* @ function direct to taphuan
			* id: 83 -> Khoá tập huấn Bộ sách giáo khoa Kết nối tri thức với cuộc sống
			* id: 84 -> Khoá tập huấn Bộ sách giáo khoa Cùng học để phát triển năng lực
			* id: 95 -> Khoá tập huấn Bộ sách giáo khoa Chân trời sáng tạo
			* id: 96 -> Khoá tập huấn Bộ sách giáo khoa Vì sự bình đẳng và dân chủ trong giáo dục
			**/
			directTrainingApp () {
				// let bookTypeId = this.ebooksDetail.bookTypeId;
				/**
				* book type id = 3: Kết nối tri thức với cuộc sống
				* book type id = 4: Chân trời sáng tạo
				**/
				// let trainingId = this.getTraningId.trainingId;
				this.ebooksDetail.trainingId && window.open(
					// live
					`https://taphuan.nxbgd.vn/giao-vien/tap-huan/${this.ebooksDetail.trainingId}?from=hts`,
					'_blank'
					// QA
					// `http://taphuan.niw.com.vn/giao-vien/tap-huan/${this.ebooksDetail.trainingId}?from=hts`,
					// '_blank'
				);
			}
		}
	};
</script>

<style lang="scss" scoped>
	.show-document{
		.inner-content{
			position: fixed;
		    // z-index: 9;
		    // width: 100%;
		    // height: 100vh;
		    // top: 0;
		    // left: 0;
		    // right: 0;
		    // bottom: 0;
		    // color: #fff;
		    // display: none;
		    // &.active{
		    // 	display: block;
		    // }
		}
		.js-background-model{
			position: fixed;
		    z-index: 1;
		 //    background-color: #08080880;
		 //    width: 100%;
		 //    height: 100vh;
		 //    top: 0;
		 //    left: 0;
		 //    right: 0;
		 //    bottom: 0;
		 //    opacity: 0;
		 //    visibility: hidden;
		 //    &.active {
			//     opacity: 1;
			//     visibility: visible;
			// }
		}
	}
</style>
